import React from "react";
import "../styles/About.css";
import FadeInSection from "./FadeInSection";


class About extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: true,
      activeKey: "1",
    };
    this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect(eventKey) {
    this.setState({
      activeKey: eventKey,
    });
  }
  render() {
    const one = (
      <p>
        I have done bachelors in <b>Computer Science and Engineering</b> from
        <a href="https://www.google.com/search?q=nith+hamirpur"  > NIT Hamirpur, Himachal Pradesh, India</a>. I am cool at web3 and <b>open source platforms.</b>
          {/*  Also I am quite good with Data Structure and Algorithms. */}
      </p>
    );
    const two = (
      <p>
        Outside of work, I'm interested in learning musical instruments, reading books. I also play lots of chess. And write articles.
      </p>
    );

    const tech_stack = [
      "Javascript",
      "React.js",
      "C++",
      "Python",
      "Solidity",
      "Rust",
    ];

    return (
      <div id="about">
        <FadeInSection>
          <div className="section-header ">
            <span className="section-title">/ about me</span>
          </div>
          <div className="about-content">
            <div className="about-description">
              {[one]}
              {"Here are some technologies I have been working with:"}
              <ul className="tech-stack">
                {tech_stack.map(function (tech_item, i) {
                  return (
                    <FadeInSection delay={`${i + 1}00ms`}>
                      <li>{tech_item}</li>
                    </FadeInSection>
                  );
                })}
              </ul>
              {[two]}
            </div>
            <div className="about-image">
              <img alt="mkbhru" src={"/assets/me2.jpg"} />
            </div>
          </div>
        </FadeInSection>
      </div>
    );
  }
}

export default About;
